import { getCurriculum } from './curriculumStorage';

const getContent = () => getCurriculum().content;

export default getContent;

export const getContentVersion = () => getCurriculum().version;

export const getStoryScript = (levelIndex, contentIndex) =>
  getCurriculum().content[levelIndex][contentIndex].script;

export const getStoryScriptPage = (levelIndex, contentIndex, pageIndex) =>
  getCurriculum().content[levelIndex][contentIndex].script[pageIndex];

export const getStoryId = (levelIndex, contentIndex) =>
  getCurriculum().content[levelIndex][contentIndex].title;

export const getTotalStoriesInLevel = levelIndex => getCurriculum().content[levelIndex].length;

export const getTargetPageOfElement = (levelIndex, contentIndex, currentPageIndex, element) => {
  const script = getStoryScript(levelIndex, contentIndex);
  // setting target index to infinity so it fails the first 'is closest' test
  // when any element is found
  let targetIndex = Infinity;
  script.forEach((page, pageIndex) => {
    page.forEach((word) => {
      // if the page has the current element and the distance is less then the current distance to target index
      // reassign target index to current (and closer) page index.
      if (word.element === element) {
        if (Math.abs(currentPageIndex - targetIndex) > Math.abs(currentPageIndex - pageIndex)) {
          targetIndex = pageIndex;
        }
      }
    });
  });
  return targetIndex;
};

export const getStoryPageCount = (levelIndex, contentIndex) =>
  getCurriculum().content[levelIndex][contentIndex].script.length;

// helper functions
export const getUniqueElementsInScript = (levelIndex, contentIndex) => {
  const uniqueItems = [];
  getStoryScript(levelIndex, contentIndex).forEach((page) => {
    const totalElements = makeArrayOfElementsInPage(page);
    totalElements.forEach((currentvalue) => {
      if (uniqueItems.indexOf(currentvalue) < 0) {
        uniqueItems.push(currentvalue);
      }
    });
  });
  return uniqueItems;
};

export const makeArrayOfElementsInPage = (script) => {
  const elements = [];
  script.forEach((currentValue) => {
    if (currentValue.element !== 'none') {
      return elements.push(currentValue.element);
    }
    return elements;
  });
  return elements;
};
